<template>
  <div>
    <v-autocomplete
      v-model="keyword"
      :items="items"
      :search-input.sync="search"
      cache-items
      flat
      hide-no-data
      hide-details
      :label="label"
      outlined
      dense
    ></v-autocomplete>
  </div>
</template>

<script>
import { authHeader } from '../_helpers';

export default {
  name: 'AppAutoComplete',
  props: ['object_name', 'api_url', 'attribute_search', 'label'],
  data: () => ({
    keyword: null,
    search: null,
    items: [],
    loading: false,
  }),
  watch: {
    search (val) {
      val && val !== this.keyword && this.searchKeyword(val)
    },
    keyword: {
      handler () {
        this.$emit('returnKeywordId', { id: this.keyword, object_name: this.object_name })
      }
    }
  },
  methods: {
    searchKeyword (val) {
      this.loading = true
      this.$http.get(`/back-office${this.api_url}?keyword=${val}`, authHeader()).then(result => {
        let { data } = result
        let items = []
        for (let item of data) {
          items.push({
            text: item[this.attribute_search],
            value: item.id
          })
        }
        this.items = items.filter(e => {
          return (e.text || '').toLowerCase().indexOf((val || '').toLowerCase()) > -1
        })
        this.loading = false
      })
    }
  },
}
</script>